import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { addDoc, collection, query, where, getDocs } from "firebase/firestore";

const DashboardClinic = () => {
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [availability, setAvailability] = useState("");
  const [listings, setListings] = useState([]);

  // Wait for auth state
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoadingUser(false);
      if (firebaseUser) {
        fetchListings(firebaseUser);
      }
    });
    return () => unsubscribe();
  }, []);

  const handleAddListing = async () => {
    if (!user) return alert("Not logged in");

    const listing = {
      clinicId: user.uid,
      title,
      description,
      price: Number(price),
      availability,
      createdAt: new Date()
    };

    console.log("🔄 Adding listing:", listing);

    try {
      await addDoc(collection(db, "listings"), listing);
      alert("✅ Service added!");
      setTitle("");
      setDescription("");
      setPrice("");
      setAvailability("");
      fetchListings(user);
    } catch (err) {
      console.error("❌ Firestore error:", err);
      alert("❌ Failed to save listing: " + err.message);
    }
  };

  const fetchListings = async (currentUser) => {
    if (!currentUser) return;
    const q = query(collection(db, "listings"), where("clinicId", "==", currentUser.uid));
    const snapshot = await getDocs(q);
    const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    console.log("📥 Fetched listings:", data);
    setListings(data);
  };

  if (loadingUser) return <p>Loading user info...</p>;
  if (!user) return <p>❌ You must be logged in as a clinic to view this page.</p>;

  return (
    <div>
      <h2>🏥 Clinic Dashboard</h2>

      <h3>Add New Service</h3>
      <input placeholder="Title" value={title} onChange={e => setTitle(e.target.value)} />
      <input placeholder="Description" value={description} onChange={e => setDescription(e.target.value)} />
      <input placeholder="Price" type="number" value={price} onChange={e => setPrice(e.target.value)} />
      <input placeholder="Availability" value={availability} onChange={e => setAvailability(e.target.value)} />
      <button onClick={handleAddListing}>Add Service</button>

      <h3>Your Listings</h3>
      {listings.length === 0 ? (
        <p>No listings found.</p>
      ) : (
        <ul>
          {listings.map(item => (
            <li key={item.id}>
              <strong>{item.title}</strong> – €{item.price}<br />
              {item.description}<br />
              <em>{item.availability}</em>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DashboardClinic;
